import http from "@/apps/shared/baseService/config";

class WalletService {
  account() { return http.get("/wallet"); }
  transactions(params) { return http.get("/wallet/transactions", { params }); }
  recipients(query) { return http.get("/wallet/recipients", { params: { q: query } }); }
  createDeposit(payload, idempotencyKey) { return http.post("/wallet/deposits/pix", payload, { headers: { "Idempotency-Key": idempotencyKey } }); }
  getDeposit(id) { return http.get(`/wallet/deposits/${id}`); }
  transfer(payload, idempotencyKey) { return http.post("/wallet/transfers", payload, { headers: { "Idempotency-Key": idempotencyKey } }); }
  createWithdrawal(payload, idempotencyKey) { return http.post("/wallet/withdrawals/pix", payload, { headers: { "Idempotency-Key": idempotencyKey } }); }
  getWithdrawal(id) { return http.get(`/wallet/withdrawals/${id}`); }
}

export default new WalletService();
